import { load } from '../utils/GoogleMapsLoader';

function install(Vue, options) {
    options = Object.assign({}, options);

    if (options.load) {
        load(options.load);
    }
}

export default {
    install,
}
